/**
 * @fileoverview Pending Review Summary query hook.
 * @description Wraps GET /approvals/summary in a TanStack query. Only a Super Admin or a Sales Head
 * may read it (anyone else is refused), so the query stays idle unless `enabled`.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { useQuery } from '@tanstack/react-query'

import { SALES_CRM_QUERY_KEYS } from '@/features/sales/constants/prospects-query-keys.constants'
import { getApprovalSummary } from '@/features/sales/services/approvals.service'

/**
 * @description Fetches the counters of every pending prospect request.
 * @param {boolean} enabled - Whether to fetch at all.
 * @returns {ReturnType<typeof useQuery>} The query (data is the counters).
 */
export function useApprovalSummary(enabled: boolean) {
  return useQuery({
    queryKey: SALES_CRM_QUERY_KEYS.approvalSummary,
    queryFn: getApprovalSummary,
    enabled,
  })
}
